module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-carusiel"
  }, [_c('div', {
    staticClass: "grid-adv is-desctop"
  }, [_c('div', {
    staticClass: "left-photo"
  }, [_c('v-avatar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": "250"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(false)
      }
    }
  }, [_c('v-img', {
    attrs: {
      "lazy-src": _vm.customer1,
      "src": _vm.adv[_vm.advBefore].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advBefore].photo)) : _vm.customer1
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "center-wrapper"
  }, [_c('img', {
    staticClass: "control-adv__left",
    attrs: {
      "src": "/static/img/adv-left.svg"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(false)
      }
    }
  }), _vm._v(" "), _c('v-avatar', {
    attrs: {
      "size": "350"
    }
  }, [_c('v-img', {
    attrs: {
      "lazy-src": _vm.customer1,
      "src": _vm.adv[_vm.advThis].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advThis].photo)) : _vm.customer1
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "control-adv__rigth",
    attrs: {
      "src": "/static/img/adv-right.svg"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(true)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-on-this"
  }, [_c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(_vm.adv[_vm.advThis].surname) + " " + _vm._s(_vm.adv[_vm.advThis].name) + " " + _vm._s(_vm.adv[_vm.advThis].patronymic) + "\n          ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "gray-text"
  }, [_vm._v("\n              Опыт работы: "), _c('span', {
    staticClass: "val-text"
  }, [_vm._v(_vm._s(_vm.adv[_vm.advThis].experience))]), _vm._v(" лет\n            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "-webkit-center"
    }
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('ui_btn', {
    attrs: {
      "type": "main-btn full-width"
    },
    on: {
      "click": function($event) {
        return _vm.toProfile(_vm.adv[_vm.advThis])
      }
    }
  }, [_vm._v("Написать")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-photo"
  }, [_c('v-avatar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": "250"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(true)
      }
    }
  }, [_c('v-img', {
    attrs: {
      "lazy-src": _vm.customer1,
      "src": _vm.adv[_vm.advLate].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advLate].photo)) : _vm.customer1
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-mobile mobile-wrapper"
  }, [_c('v-avatar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": "150"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(false)
      }
    }
  }, [_c('v-img', {
    staticClass: "small-img",
    attrs: {
      "lazy-src": _vm.customer1,
      "src": _vm.adv[_vm.advBefore].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advBefore].photo)) : _vm.customer1
    }
  })], 1), _vm._v(" "), _c('v-avatar', {
    staticClass: "av-center",
    attrs: {
      "size": "223"
    }
  }, [_c('v-img', {
    attrs: {
      "lazy-src": _vm.customer1,
      "src": _vm.adv[_vm.advThis].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advThis].photo)) : _vm.customer1
    }
  })], 1), _vm._v(" "), _c('v-avatar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": "150"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(true)
      }
    }
  }, [_c('v-img', {
    staticClass: "small-img",
    attrs: {
      "lazy-src": _vm.customer1,
      "src": _vm.adv[_vm.advLate].photo ? (_vm.getApi + "file/" + (_vm.adv[_vm.advLate].photo)) : _vm.customer1
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "is-mobile mobile-info-on-this"
  }, [_c('div', {
    staticStyle: {
      "text-align": "-webkit-center",
      "margin-top": "1em"
    }
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("\n        " + _vm._s(_vm.adv[_vm.advThis].surname) + " " + _vm._s(_vm.adv[_vm.advThis].name) + " " + _vm._s(_vm.adv[_vm.advThis].patronymic) + "\n      ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "gray-text"
  }, [_vm._v("\n          Опыт работы: "), _c('span', {
    staticClass: "val-text"
  }, [_vm._v(_vm._s(_vm.adv[_vm.advThis].experience))]), _vm._v(" лет\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('img', {
    staticClass: "control-adv__left",
    staticStyle: {
      "width": "34px",
      "height": "34px"
    },
    attrs: {
      "src": "/static/img/adv-left.svg"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(false)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "control-adv__rigth",
    staticStyle: {
      "width": "34px",
      "height": "34px"
    },
    attrs: {
      "src": "/static/img/adv-right.svg"
    },
    on: {
      "click": function($event) {
        return _vm.changeBannerAdv(true)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "-webkit-center"
    }
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('ui_btn', {
    attrs: {
      "type": "main-btn"
    },
    on: {
      "click": function($event) {
        return _vm.toProfile(_vm.adv[_vm.advThis])
      }
    }
  }, [_vm._v("Написать")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16401a3f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advCarusiel.vue
// module id = 340
// module chunks = 2